import { filterUndefined } from '../../../../../utils/FilterUndefinedObject';
import { useTeacherCurriculum } from '../../../common/context/TeacherCurriculumContextProvider';
import PdfContainer from './PdfContainer';

const defaultProps = {
  loadingMessage: null,
};
const GuideScopeAndSequence = (p) => {
  const {
    loadingMessage,
  } = { ...defaultProps, ...filterUndefined(p) };
  const { teacherCurriculumDomain } = useTeacherCurriculum();
  const { scopeAndSequenceLink } = teacherCurriculumDomain.domainData;

  return (
    <PdfContainer
      pdfKey={scopeAndSequenceLink}
      loadingMessage={loadingMessage}
      noPdfFoundMessage='No Sequence Guide available'
    />
  );
};

export default GuideScopeAndSequence;
